import { Component, input, output, ChangeDetectionStrategy } from "@angular/core";
import { Customer } from "../../master-data/master-data.model";

@Component({
    selector: "app-customer-card",
    templateUrl: "./customer-card.component.html",
    styleUrls: ["./customer-card.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerCardComponent {
  readonly customer = input<Customer>(undefined);
  readonly clearSelection = output();

  clearCustomer() {
    this.clearSelection.emit();
  }
}
